module.exports = __webpack_public_path__ + "img/icon-paper-plane.159d7d0a.svg";